import { ChangeLogTable } from "../components/ChangeLogTable";
import { Notice } from "../components/Notice";
import { QueryErrorState, TabHeading, TabSkeleton } from "../components/tab-states";
import { useChangeLog } from "../data/queries";
import { useChangeLogItemScope } from "../navigation";

/** Every tactic application event, including reversals, with its Amazon result. */
export function ChangeLogTab() {
  const changeLog = useChangeLog();
  const { item, clearItem } = useChangeLogItemScope();

  return (
    <div className="flex flex-col gap-4">
      <TabHeading
        title="Change Log"
        description="Every tactic application event, including reversals, with its Amazon result and provenance."
      />
      {changeLog.isPending ? (
        <TabSkeleton />
      ) : changeLog.isError ? (
        <QueryErrorState title="Change log unavailable" onRetry={() => changeLog.refetch()} />
      ) : !changeLog.data || changeLog.data.length === 0 ? (
        <Notice title="No application events recorded">
          Nothing is inferred and no mock data is shown.
        </Notice>
      ) : (
        <ChangeLogTable rows={changeLog.data} item={item} onClearItem={clearItem} />
      )}
    </div>
  );
}
